import { Spinner } from "spin.js";
import { getXMLData, CookieManager } from "./Toolkit.js";

// variables to handle populateDropdown function
let citiesCount = 0;
let citiesXMLObject;
let lstCities;
let option;

// variables to handle onPopulatePage function and main function
let weatherXMLObject;
let listItem;
let cityTarget;
let mainIcon;
let mainIconNum;
let mainWeather;
let mainIconClass;
let sunriseTime;
let sunrise;
let sunset;
let sunsetTime;
let currentTemp;
let lowTemp;
let highTemp;
let humidity;
let air;
let windCode;
let windIconClass;
let windDirection;
let windSpeed;
let windPower;
let windIcon;
let sunriseValue;
let sunsetValue;
let mainLocation;

// variables to handle onChanged function and cookie
let cookie = null;
let lastCity;

// variables to handle spinner and gray-out effect
let spinner;
let loadingOverlay;


spinner = new Spinner({ color: '#000000', lines: 12 }).spin(document.getElementsByClassName("loading-overlay")[0]);

function populateDropdown() {
    // populate the dropdown menu
    for (let i=0; i<citiesCount; i++) {
        // create element for dropdown
        option = document.createElement("option");
        option.text = citiesXMLObject.getElementsByTagName("name")[i].textContent + ", " + citiesXMLObject.getElementsByTagName("province")[i].textContent;
        option.location = option.text;

        // add elements to lstCities variable
        lstCities.add(option, null);

        // if statemant to load cookie from the last city visited
        if (cookie.retrieveCookie("Last Location", lastCity, 365) == option.text) {
            option.setAttribute("selected", "selected");
        }
    }

    // event listener to onChanged function
    lstCities.addEventListener("change", onChanged);
}

function onPopulatePage(result) {
    // receive xml from weather API
    weatherXMLObject = result;
    mainIconNum = weatherXMLObject.getElementsByTagName("weather")[0].getAttribute("number");
    // create class and assign value for the bigger icon
    mainIconClass = document.createAttribute("class");
    mainIconClass.value = "wi wi-owm-" + mainIconNum;
    mainIcon.setAttributeNode(mainIconClass);
    // name for the city chosen
    mainWeather.innerHTML = weatherXMLObject.getElementsByTagName("weather")[0].getAttribute("value");
    // converting sunrise time
    sunriseTime = weatherXMLObject.getElementsByTagName("sun")[0].getAttribute("rise");
    sunriseTime = sunriseTime.replace("T", " ");
    // add Z to adjust time
    sunriseTime = sunriseTime + "Z";
    // date constructor
    sunrise = new Date(sunriseTime);
    // format date and time according to locale and remove the comma
    sunriseValue.innerHTML = sunrise.toLocaleString().replace(",", "");
    // adjust style
    sunriseValue.style.fontFamily = "Arial, Helvetica, sans-serif";
    // converting sunset time
    sunsetTime = weatherXMLObject.getElementsByTagName("sun")[0].getAttribute("set");
    sunsetTime = sunsetTime.replace("T", " ");
    sunsetTime = sunsetTime + "Z";
    sunset = new Date(sunsetTime);
    sunsetValue.innerHTML = sunset.toLocaleString().replace(",", "");
    sunsetValue.style.fontFamily = "Arial, Helvetica, sans-serif";
    // use round method to round temperature
    currentTemp.innerHTML = Math.round(weatherXMLObject.getElementsByTagName("temperature")[0].getAttribute("value")) + "°C Current";
    lowTemp.innerHTML = Math.round(weatherXMLObject.getElementsByTagName("temperature")[0].getAttribute("min")) + "°C Low";
    highTemp.innerHTML = Math.round(weatherXMLObject.getElementsByTagName("temperature")[0].getAttribute("max")) + "°C High";
    humidity.innerHTML = weatherXMLObject.getElementsByTagName("humidity")[0].getAttribute("value") + "%";
    air.innerHTML = weatherXMLObject.getElementsByTagName("pressure")[0].getAttribute("value") + "hPa";
    // grab the wind code lower case to use in icon class
    windCode = (weatherXMLObject.getElementsByTagName("direction")[0].getAttribute("code")).toLowerCase();
    windIconClass = document.createAttribute("class");
    windIconClass.value = "wi wi-wind wi-towards-" + windCode;
    windIcon.setAttributeNode(windIconClass);
    windDirection.innerHTML = weatherXMLObject.getElementsByTagName("direction")[0].getAttribute("name") + " wind";
    // convert mps to kph and adjust to 2 decimal places
    windSpeed.innerHTML = (weatherXMLObject.getElementsByTagName("speed")[0].getAttribute("value") * 3.6).toFixed(2) + " km/h";
    windPower.innerHTML = weatherXMLObject.getElementsByTagName("speed")[0].getAttribute("name");
    // display content back after city not found
    document.getElementsByClassName("details")[0].style.display = "flex";
    // display opacity to default and remove overlay after load all elements
    document.getElementsByTagName("body")[0].style.opacity = "1";
    loadingOverlay.style.display = "none";

}

function onCityError(e) {
    // hide detailed weather information from user
    document.getElementsByClassName("details")[0].style.display = "none";
    mainIconClass = document.createAttribute("class");
    // display N/A icon
    mainIconClass.value = "wi wi-na";
    mainIcon.setAttributeNode(mainIconClass);
    // insert blank to city name and display a message to user
    mainWeather.innerHTML = " ";
    mainLocation.innerHTML = "City not found :(";
    // display opacity to default
    document.getElementsByTagName("body")[0].style.opacity = "1";
}

// ------------------------------------------------------- event handlers
function onLoaded(result) {
    // receive xml with city and call populateDropdown and onChanged functions
    citiesXMLObject = result;
    citiesCount = citiesXMLObject.getElementsByTagName("city").length;
    if(citiesCount > 0) {
        populateDropdown();
        onChanged();
    }
}


function onError(e) {
    console.log("Error has occured during AJAX data retrieval");
}

function onChanged(e) {
    // gray out effect to appear on change cities
    document.getElementsByTagName("body")[0].style.opacity = "0.2";
    listItem = lstCities.selectedOptions[0];
    // use regex to remove all chars after comma
    cityTarget = listItem.textContent.replace(/,.*/, "");
    weatherXMLObject = "http://api.openweathermap.org/data/2.5/weather?q=" + cityTarget + ",CA&mode=xml&appid=62babe4a87424dc8a3777e4b3e6fde36&units=metric";
    mainLocation.innerHTML = listItem.location;
    // fetch weather xml, populate page on change, call onCityError function if no city is found
    getXMLData(weatherXMLObject, onPopulatePage, onCityError);
    // store current visited city to be used on cookiemanager
    lastCity = lstCities.selectedOptions[0].value;
    cookie.setupCookie("Last Location", lastCity, 365);

}

// ------------------------------------------------------- private methods
function main() {
    // grayout page while loading content
    document.getElementsByTagName("body")[0].style.opacity = "0.2";
    // store city xml to variable
    citiesXMLObject = "cities.xml";
    lstCities = document.getElementById("lstCities");
    // cookiemanager constructor
    cookie = new CookieManager();
    // populate icons and data
    mainIcon = document.getElementsByClassName("status status--icon")[0].firstChild;
    mainWeather = document.getElementsByClassName("status status--weather")[0];
    mainLocation = document.getElementsByClassName("status status--location")[0];
    sunriseValue = document.getElementsByClassName("details__sunrise")[0].childNodes[1].childNodes[0];
    sunsetValue = document.getElementsByClassName("details__sunset")[0].childNodes[1].childNodes[0];
    currentTemp = document.getElementsByClassName("details__current__temperature")[0];
    lowTemp = document.getElementsByClassName("details__low__temperature")[0];
    highTemp = document.getElementsByClassName("details__high__temperature")[0];
    humidity = document.getElementsByClassName("details__humidity__percent")[0];
    air = document.getElementsByClassName("details__air__pressure")[0];
    windIcon = document.getElementsByClassName("details__wind__icon")[0].firstChild;
    windDirection = document.getElementsByClassName("details__wind__direction")[0];
    windPower = document.getElementsByClassName("details__wind__power")[0];
    windSpeed = document.getElementsByClassName("details__wind__speed")[0];
    loadingOverlay = document.getElementsByClassName("loading-overlay")[0];
    // function to retrieve city xml, call onLoad function and onError in case of failing retrieving xml data
    getXMLData(citiesXMLObject, onLoaded, onError);

}

main();